// let routesConfig = [
//    {
//      "id": "GROUP_USER_MANAGEMENT",
//      "title": "General",
//      "messageId": "menu.title.group.user.management",
//      "url": "/group-user-management",
//      "group": [
//        {
//          "id": "MNU_VENDOR_USER_MANAGEMENT",
//          "title": "User Management",
//          "messageId": "menu.title.user.management",
//          "path": "/user-management"
//        },
//        {
//          "id": "MNU_USER_GROUP",
//          "title": "Icon",
//          "messageId": "menu.title.user.group",
//          "path": "/user-group"
//        }
//      ]
//    },
//    {
//      "id": "GROUP_CASH_PICKUP",
//      "title": "Group Cash Pickup",
//      "messageId": "menu.title.group.cash.pick.up",
//      "url": "/group-cash-pickup",
//      "group": [
//        {
//          "id": "MNU_ORDER_CASH_PICKUP",
//          "title": "Order Cash Pick Up",
//          "messageId": "menu.title.cash.order.pick.up",
//          "path": "/order-cash-pick-up"
//        },
//        {
//          "id": "MNU_VAULTING_CASH_PICKUP",
//          "title": "CPC Vaulting Cash Pick Up",
//          "messageId": "menu.title.cpc.vaulting.cash.pick.up",
//          "path": "/cpc-vaulting-cash-pick-up"
//        },
//        {
//          "id": "MNU_SORTASI_CASH_PICKUP",
//          "title": "CPC Sortasi Cash Pick Up",
//          "messageId": "menu.title.cpc.sortasi.cash.pick.up",
//          "path": "/order-cash-pick-up-sortasi"
//        },
//        {
//          "id": "MNU_CHECKIN_ACCEPTANCE_CASH_PICKUP",
//          "title": "Service Cash Pick Up",
//          "messageId": "menu.title.service.cash.pick.up",
//          "path": "/service-cash-pick-up"
//        },
//        {
//          "id": "MNU_UANG_DIRAGUKAN_CASH_PICKUP",
//          "title": "Penanganan Uang Diragukan",
//          "messageId": "menu.title.uang.diragukan",
//          "path": "/penanganan-uang-diragukan"
//        }
//      ]
//    },
//    {
//      "id": "GROUP_CASH_DELIVERY",
//      "title": "Group Service Cash Delivery",
//      "messageId": "menu.title.group.service.cash.delivery",
//      "url": "/group-cash-delivery",
//      "group": [
//        {
//          "id": "MNU_ORDER_CASH_DELIVERY",
//          "title": "CIT Maker",
//          "messageId": "menu.title.cash.order.delivery.cit.maker",
//          "path": "/order-cash-delivery-cit-maker"
//        },
//        {
//          "id": "MNU_CPC_ORDER_CASH_DELIVERY",
//          "title": "CPC Maker",
//          "messageId": "menu.title.service.cash.delivery.cpc.maker",
//          "path": "/service-cash-delivery-cpc-maker"
//        },
//        {
//          "id": "MNU_CHECKIN_SENDING_CASH_DELIVERY",
//          "title": "CIT Executor",
//          "messageId": "menu.title.service.cash.delivery.cit.executor",
//          "path": "/service-cash-delivery-cit-executor"
//        }
//      ]
//    },
//    {
//      "id": "GROUP_CASH_MOVEMENT",
//      "title": "Group Cash Movement",
//      "messageId": "menu.title.group.cash.pick.movement",
//      "url": "/group-cash-movement",
//      "group": [
//        {
//          "id": "MNU_ORDER_CASH_MOVEMENT",
//          "title": "Order Cash Movement",
//          "messageId": "menu.title.cash.movement",
//          "path": "/order-cash-movement"
//        },
//        {
//          "id": "MNU_INPUT_SEAL_NO_CASH_MOVEMENT",
//          "title": "Service Cash Movement",
//          "messageId": "menu.title.header.service.cash.movement",
//          "path": "/service-cash-movement-noseal"
//        },
//        {
//          "id": "MNU_ACCEPTANCE_CASH_MOVEMENT",
//          "title": "Service Cash Movement",
//          "messageId": "menu.title.header.service.cash.movement",
//          "path": "/service-cash-movement-acceptance"
//        },
//        {
//          "id": "MNU_VAULTING_CASH_MOVEMENT",
//          "title": "Service Cash Movement",
//          "messageId": "menu.title.header.service.cash.movement",
//          "path": "/service-cash-movement-vaulting"
//        }
//      ]
//    },
//    {
//      "id": "MNU_PENDING_TASK",
//      "title": "Pending Task",
//      "messageId": "menu.title.pending.task",
//      "path": "/pending-task"
//    }
//    ];

let routesConfig = [];
export default routesConfig;
